<div *ngIf="templateId" class="modal-header">
  <h5 class="modal-title">{{ options.title }}
    <div class="form-check form-switch mr-3 offline" *ngIf="options?.allowEmpty">
      <input type="checkbox" role="switch" class="form-check-input" id="swEmpty" [(ngModel)]="empty">
      <label class="form-check-label" for="swEmpty">{{'lang.globals.emptyValue'|translate}}</label>
    </div>
  </h5>
</div>
<div [ngClass]="getBodyClass()">
  <p *ngIf="!singleMode">{{ 'lang.globals.selectedValues' | translate }}</p>
  <p *ngIf="singleMode">{{ 'lang.globals.selectedValue' | translate }}</p>
  <div class="mydropdown">
    <ng-scrollbar [style.height.px]="singleMode ? 52 : 200">
      <button *ngFor="let result of selectedOptions" class="dropdown-item cursor-remove" [ngClass]="getClass(result)"
              type="button" (click)="remove(result)">
        <ng-container [ngSwitch]="attributeType">
          <ng-container *ngSwitchCase="'PERMISSION'">
            {{ getName(result) | sbPermissionTranslate }}
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{getName(result)}}
          </ng-container>
        </ng-container>
        <br>
        <div style="font-size: smaller;">
          {{getDescription(result)}}
        </div>
      </button>
    </ng-scrollbar>
  </div>

  <br>

  <div>
    <input [(ngModel)]="searchStr" (ngModelChange)="dosearch($event)" type="text" class="form-control"
           placeholder="{{'lang.globals.searchPlaceholder' | translate}}" aria-label="Search"
           aria-describedby="basic-addon2" sbAutofocus>
  </div>

  <br>

  <div class="mydropdown">
    <ng-scrollbar [style.height.px]="singleMode ? 448 : 300">
      <button *ngFor="let result of displayResults" class="dropdown-item cursor-add" [ngClass]="getClass(result)"
              type="button"
              (click)="add(result)" (dblclick)="ok()">
        <ng-container [ngSwitch]="attributeType">
          <ng-container *ngSwitchCase="'PERMISSION'">
            {{ getName(result) | sbPermissionTranslate }}
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{getName(result)}}
          </ng-container>
        </ng-container>
        <br>
        <div style="font-size: smaller;">
          {{getDescription(result)}}
        </div>
      </button>
    </ng-scrollbar>
  </div>

  <br>

  <div *ngIf="attributeType !== 'PERMISSION'" class="d-flex align-items-center justify-content-between">
    <div sb-pagination [showPageSize]="false" [showGotoPage]="false" *ngIf="paginationInitialized" [collectionSize]="collectionSize"
         [(page)]="page"
         (pageChange)="pageChange($event)" [maxSize]="maxSize" [boundaryLinks]="boundaryLinks" [showPageCount]="false">
    </div>
  </div>

  <br>

  <div *ngIf="attributeType !== 'PERMISSION'" class="d-flex align-items-center justify-content-between">
    <div class="pagination__options">
      <!-- <div ngbDropdown class="d-inline-block">
        <sb-button ngbDropdownToggle classes="btn-primary">{{maxSize}} <fa-icon [icon]="'chevron-down'"></fa-icon></sb-button>
        <div ngbDropdownMenu>
          <ul class="dropdown">
            <li ngbDropdownItem *ngFor="let size of sizes" class="item" (click)="setMaxSize(size)" [ngClass]="size === maxSize ? 'active' : ''">
              {{size}}
            </li>
          </ul>
        </div>
      </div> -->
      <span class="mr-2">{{paginationString}}</span>
    </div>
  </div>

</div>
<div *ngIf="templateId" class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()" [disabled]="!checkOkEnabled()">{{ 'lang.globals.ok' | translate }}
  </sb-button>
  <sb-button classes="btn-default" (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
  </sb-button>
</div>
